export const YOUTUBE = 'YouTube';

export const profile = {
    NOT_FOUND: 'not-found'
};

export const tenantMeta = {
    TENANT_ID: 'https://sponsors.makrwatch.com/tenant_id'
};

export const performanceMetric = {
    rateCalculationId: 'f002fcb4-d456-4ae2-8c71-b5358229472a',
    numberFormatId: 'fd6972c0-e490-4919-9fd9-3a1b4ad21508',
    currencyFormatId: 'eb441d0a-fcb0-48b9-a3b3-3e7f0d86add4',
    percentageFormatId: '71809229-3941-4da5-80ff-9e3820ddc6eb'
};

export const publicationStatus = {
    tentative: '00430813-9789-481f-b84c-aeb41a6bdadd',
    scheduled: 'c656a5ee-cc37-4e0f-b1fa-8d922a32d5ad',
    inReview: 'a64637bf-2574-49b6-bbb3-94f75264704a',
    approved: '988c4a2d-4ef8-4741-a9e7-87b8f415bfa6',
    pendingReview: '2b7672e9-1ea6-4fc8-bbea-a66745e119c5',
    publishAfterEdits: '18d368ad-5f9c-458a-9e04-16648c155f67',
    readyToPublish: '9ab4ae7d-9cf0-4a19-873c-2221889e3d50',
    needsEdits: '946e2973-918b-4de9-84d0-794634df66d3',
    published: 'd0d46dae-f3c6-4802-b8d9-495d0261ebbe',
    unavailable: 'a9d9d360-4c87-414c-b08d-6935085e1c35'
};

export const partner = {
    makrwatch: 'd7a6a6e5-e774-4d09-9d82-b49606b6f512'
};

export const metricName = {
    cpm: 'costperthousand', 
    cpc: 'costperclick',
    ctr: 'clickthroughrate',
    clicks: 'clicks',
    views: 'views',
    conversions: '_conversions'
};

export const publicationStatusName = {
    TENTATIVE: 'Tentative',
    SCHEDULED: 'Scheduled',
    IN_REVIEW: 'In Review',
    APPROVED: 'Approved',
    PUBLISHED: 'Published',
    READY_TO_PUBLISHED: 'Ready to Publish',
    PENDING_REVIEW: 'Pending Review',
    NEEDSE_DITS: 'Needs Edits',
    PUBLISH_AFTER_EDITS: 'Publish After Edits'
};

export const culturesName = {
      ENGLISH: 'English',
      SPANISH: 'Spanish',
      PORTUGUESE: 'Portuguese'
};
  
export const typeOfContract = [
    {id:'fixedPrice', name: 'Fixed Price'},
    {id:'pbd', name: 'Performance Based Deal' }
];

export const dealStatus = {
    contract_signed: '863e55a2-1710-4f7b-b6c4-ec61dd247e6f'
};
